/* Kyma — coupon entry for the cart drawer.

   Shopify's Ajax cart API has no discount endpoint, but hitting
   /discount/{CODE} sets the discount cookie for the session. We fetch it,
   then re-render the drawer from /?sections=cart-drawer so the totals and
   savings line update without navigating away. */

if (!customElements.get('kyma-coupon')) {
  customElements.define(
    'kyma-coupon',
    class KymaCoupon extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.kyma-coupon__input');
        this.button = this.querySelector('[data-apply]');
        this.msg = this.querySelector('.kyma-coupon__msg');

        this.button?.addEventListener('click', this.apply.bind(this));
        this.input?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.apply();
          }
        });
      }

      setMessage(text, isError) {
        if (!this.msg) return;
        this.msg.textContent = text || '';
        this.msg.classList.toggle('is-error', !!isError);
      }

      async apply() {
        const code = (this.input?.value || '').trim();
        if (!code) {
          this.setMessage('Enter a code first.', true);
          this.input?.focus();
          return;
        }

        this.button.disabled = true;
        this.setMessage('Applying…', false);

        try {
          // Sets the discount cookie for this session.
          await fetch(`${window.Shopify.routes.root}discount/${encodeURIComponent(code)}`, {
            method: 'GET',
            credentials: 'same-origin',
          });

          const res = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
          const data = await res.json();
          const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          const fresh = html.querySelector('#CartDrawer');
          const current = document.querySelector('#CartDrawer');

          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            document.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => {
              document.querySelector('cart-drawer')?.close();
            });
          }

          // Shopify returns 200 for an invalid code too, so check whether the
          // cart actually changed rather than assuming success.
          const applied = html.querySelector('.discounts__discount');
          const node = document.querySelector('#CartDrawer .kyma-coupon__msg');
          if (node) {
            node.textContent = applied
              ? 'Code applied.'
              : "That code isn't valid for this cart.";
            node.classList.toggle('is-error', !applied);
          }
        } catch (e) {
          this.setMessage('Could not apply that code. Try again.', true);
        } finally {
          if (this.button) this.button.disabled = false;
        }
      }
    }
  );
}
